// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1v9T2","rootCenter":"LoadMoreObserver_rootCenter__1v32D","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2XLf5"};